import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0c565cd3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "gap": "8px"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Connected", -1));
const _hoisted_3 = {
  key: 2
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_stroked_tick_icon = _resolveComponent("stroked-tick-icon");
  const _component_flex_row = _resolveComponent("flex-row");
  return _openBlock(), _createBlock(_component_flex_row, {
    class: _normalizeClass(["account-connection-status", [$props.status]]),
    gap: 4,
    align: "left",
    style: {
      padding: '4px 0'
    }
  }, {
    default: _withCtx(() => [$props.status === 'inactive' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", null, [_createVNode(_component_app_icon, {
      icon: "connection-expired"
    }), _createTextVNode(" Connection expired")]), _createElementVNode("span", {
      class: "status",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('reauthenticate-account'))
    }, " Reauthenticate ")])) : $props.status === 'active' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createVNode(_component_stroked_tick_icon, {
      color: "#22863D"
    }), _hoisted_2], 64)) : (_openBlock(), _createElementBlock("span", _hoisted_3, "Unknown"))]),
    _: 1
  }, 8, ["class"]);
}